module.exports = "/_next/static/images/shopify-logo-1e72e870cf27e6e5ea8af17d6aca2f2a.png";